"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledContainer = styled_components_1.default.div `
  margin-left: -48px;
  margin-right: -48px;
  @media (max-width: 768px) {
    margin-left: -16px;
    margin-right: -16px;
  }
`;
const StyledHeader = styled_components_1.default.a `
  cursor: pointer;
  padding: 8px 48px 24px;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorBrandInteractiveBlue};
  text-decoration: none;
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 18px;
    padding: 8px 16px 16px;
  }
`;
const CollapseIcon = styled_components_1.default.img `
  margin-left: 8px;
  width: 8px;
  height: 8px;
`;
const StyledContent = styled_components_1.default.div `
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;

  &.active {
    margin-bottom: 24px;
    max-height: 1000px;
  }
`;
const StyledText = styled_components_1.default.div `
  padding: 24px 48px;
  background-color: ${tokens.ColorWhite025};
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey600};
  @media (max-width: 767px) {
    padding: 24px 16px;
  }
`;
class CollapsibleHedge extends react_1.Component {
    constructor(props) {
        super(props);
        this.togglePanel = () => {
            !this.state.isOpen
                ? this.setState({ isOpen: true })
                : this.setState({ isOpen: false });
        };
        this.keyDown = (e) => {
            let code = e.key;
            if (code === 'Enter' || code === ' ') {
                !this.state.isOpen
                    ? this.setState({ isOpen: true })
                    : this.setState({ isOpen: false });
            }
        };
        this.state = {
            isOpen: false,
            active: false
        };
    }
    render() {
        const { title, bodyCopy } = this.props;
        return (react_1.default.createElement(StyledContainer, { id: 'collapsible-hedge-container' },
            react_1.default.createElement(StyledHeader, { id: 'collapsible-hedge-header', onClick: this.togglePanel, tabIndex: 0, onKeyPress: this.keyDown },
                title,
                react_1.default.createElement(CollapseIcon, { id: 'collapsible-hedge-icon', alt: "Select option dropdown arrow", src: this.state.isOpen
                        ? `data:image/svg+xml;base64,${tokens.AssetIconDropdownUpArrowBlue}`
                        : `data:image/svg+xml;base64,${tokens.AssetIconDropdownDownArrowBlue}` })),
            react_1.default.createElement(StyledContent, { id: 'collapsible-hedge-content', className: this.state.isOpen ? "active" : "" },
                react_1.default.createElement(StyledText, { id: 'collapsible-hedge-text', dangerouslySetInnerHTML: { __html: bodyCopy } }))));
    }
}
exports.default = CollapsibleHedge;
//# sourceMappingURL=CollapsibleHedge.js.map